import React from 'react';
import MuiGrid from '../../../UI/MuiGrid/MuiGrid';
import GridOptions from './GridOptions';
import { useTranslation } from 'react-i18next';
import { formatDateFromDB } from '../../../../../utils/FormatDate';
import { icons } from '../../../../../shared/icons';

const GridProvider = ({ data, handleOpenDeleteDialog, handleEditData }) => {
  const { t, i18n } = useTranslation();
  const columns = [
    {
      field: 'id',
      disableExport: true,
      headerName: 'Opcije',
      width: 70,
      sortable: false,
      filterable: false,
      renderCell: (e) => (
        <GridOptions
          handleOpenDialog={() => handleOpenDeleteDialog(e.id)}
          getEditData={() => handleEditData(e.row)}
        >
          <button className="header-options">{icons.MENU_ICON}</button>
        </GridOptions>
      ),
    },

    { field: 'naziv', headerName: 'Naziv', width: 200 },
    { field: 'opis', headerName: 'Opis', width: 200 },
    { field: 'nazivTipaMasine', headerName: 'Tip mašine', width: 200 },

    {
      field: 'vremeKreiranja',
      headerName: 'Datum kreiranja',
      renderCell: (e) => formatDateFromDB(e.row.vremeKreiranja),
      width: 180,
    },
  ];
  return (
    <div style={{ height: '75vh', width: '99%' }}>
      <MuiGrid data={data} columns={columns} />
    </div>
  );
};

export default GridProvider;
